import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";
import OmniTextField from "../ui/omniTextField";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionZipDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const defaultDelay = 350;

  const [validAnswerSelected, setValidAnswerSelected] = useState(question.answerValue != null);

  const [postalCode, setPostalCode] = useState("");

  const [unsure, setUnsure] = useState(false);

  useEffect(() => {
    if (question.answerValue && question.answerValue[0] === "unsure") {
      setUnsure(true);
    } else if (question.answerValue && question.answerValue[0]) {
      setPostalCode(question.answerValue[0]);
    }
  }, [question]);

  useEffect(() => {
    if (!unsure && postalCode.length === 5) {
      //valid date
      onAnswerSelected([postalCode]);
      setValidAnswerSelected(true);
    } else {
      setValidAnswerSelected(false);
    }
  }, [postalCode, unsure, onAnswerSelected, setValidAnswerSelected]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          sx={{ justifyContent: "center", display: "flex", width: "100%", flexDirection: "row" }}
        >
          <OmniTextField
            sx={{ width: "100px" }}
            key={`answerOptionQuestion${question.omniID}`}
            name={uuid()}
            value={postalCode}
            label={"Zip Code"}
            type="number"
            showNumberControls={false}
            error={postalCode.length !== 5}
            onFocus={event => event.target.select()}
            onChange={event => {
              let onlyNums = event.target.value.replace(/[^0-9]/g, "");
              onlyNums = onlyNums.slice(0, 5);
              setUnsure(false);
              setPostalCode(onlyNums);
            }}
            autoFocus
            onKeyPress={e => {
              if (e.key === "Enter" && validAnswerSelected) {
                startNextTimer(defaultDelay);
              }
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: theme.spacing(2) }}>
        <Grid
          id={`questionGrid1`}
          container
          item
          xs={11}
          justifyContent="center"
          spacing={2}
          sx={{ marginLeft: "0", padding: "0" }}
        >
          <Tooltip title={question.answerOptions[0].helpText || ""} placement="left">
            <Fragment>
              <OmniAssessmentValueTextFab
                key={`answerOption${uuid()}`}
                color="primary"
                size="large"
                variant={"outlined"}
                onClick={e => {
                  setUnsure(true);
                  onAnswerSelected(["unsure"]);
                  startNextTimer(defaultDelay);
                }}
                sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
              >
                <Grid
                  container
                  justifyContent="center"
                  direction="row"
                  sx={{ width: "100%", alignItems: "center" }}
                >
                  <Grid item justifySelf="center" xs>
                    <Typography
                      variant="button"
                      dangerouslySetInnerHTML={getAnswerTextAsHTML("I don't know")}
                    />
                  </Grid>
                  {unsure && (
                    <CheckCircleRoundedIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 16,
                        maxWidth: "32px",
                        maxHeight: "32px",
                        alignSelf: "baseline",
                      }}
                    />
                  )}
                </Grid>
              </OmniAssessmentValueTextFab>
            </Fragment>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default QuestionZipDisplay;
